import { __awaiter, __generator } from "tslib";
import '../polyfill';
import { reportHomePageLoadedDuration, reportHomePagePaintDuration } from '../../logger/homePageLoad';
import { registerDingtalkPerformance } from '../../lib/utils';
import { bootstrap, appDataInitialize } from './bootstrap';
import { logFilesWhichUseBrowserCache } from '../../lib/log-cache-info';
if (process.env.NODE_ENV === 'production' &&
    (/dd2\.ekuaibao\.com/.test(window.location.hostname) ||
        /ekuaibao2297\.eapps\.dingtalkcloud\.com/.test(window.location.hostname))) {
    if ('requestIdleCallback' in window) {
        requestIdleCallback(function () {
            require('./dingdingProbe');
        });
    }
    else {
        setTimeout(function () {
            require('./dingdingProbe');
        }, 1000);
    }
}
registerDingtalkPerformance();
if (!Object.values) {
    Object.values = function (obj) {
        if (obj !== Object(obj))
            throw new TypeError('Object.values called on a non-object');
        var val = [], key;
        for (key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                val.push(obj[key]);
            }
        }
        return val;
    };
}
window.addEventListener('load', function () {
    if ('requestIdleCallback' in window) {
        requestIdleCallback(function () {
            reportHomePageLoadedDuration();
            reportHomePagePaintDuration();
        });
    }
    else {
        setTimeout(function () {
            reportHomePageLoadedDuration();
            reportHomePagePaintDuration();
        }, 100);
    }
});
appDataInitialize();
window.addEventListener('DOMContentLoaded', function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        bootstrap();
        logFilesWhichUseBrowserCache();
        return [2];
    });
}); });
